import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["src"]

import Card from 'primevue/card'
import { onMounted, ref } from 'vue'
import InlineSvg from 'vue-inline-svg'
import apiUsecase from '@/usecase/apiUseCase'


export default /*#__PURE__*/_defineComponent({
  __name: 'Metabase',
  setup(__props) {

const totalRecod = ref(0)
const isLoading = ref(true)
const iframeUrl = ref('')
const metabaseSiteUrl = 'https://metabase.harapan-jaya.com'
const metabaseSecretKey = 'b243c1b5f9a607c7f100168aa6c6bd0b038e82bb4bd472e096e76e6fc6178bc2'

const initialize = () => {
  apiUsecase.get('transaction/v1/Dashboard/PendapatanPerBusBerjalan', '?pageSize=200')
    .then(({ error, count }) => {
      if (!error) {
        // console.log('count', count)
        totalRecod.value = count
      }
    })
}

const init = () => {
  console.log('zzz')
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const jwt = require('jsonwebtoken')

  const payload = {
    resource: { dashboard: 14 },
    params: {},
    exp: Math.round(Date.now() / 1000) + (10 * 60)
  }
  console.log('payload', payload)
  // const options = { expiresIn: '1h' }
  const token = jwt.sign(payload, metabaseSecretKey)
  console.log('token', token)

  iframeUrl.value = `${metabaseSiteUrl}/embed/dashboard/${token}#bordered=true&titled=true`
  console.log('iframeUrl', iframeUrl.value)
  isLoading.value = false
}

onMounted(() => {
  console.log('xxx')
  init()
})

return (_ctx: any,_cache: any) => {
  return (!isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("iframe", {
          class: "w-full",
          src: iframeUrl.value,
          frameborder: "0",
          style: {"height":"100vh"}
        }, null, 8, _hoisted_2)
      ]))
    : _createCommentVNode("", true)
}
}

})